const a = () => Math.random().toString(36).substring(7), e = (...t) => [...t].filter((s) => s).filter((s) => typeof s == "string").map((s) => s).join(" ");
export {
  e as composeClassNames,
  a as makeUniqueId
};
//# sourceMappingURL=index.es88.js.map
